import React from 'react';
import { getTotalHeaderHeight } from 'Utils';
import Navigation from './Navigation';
import styles from './SplitView.css';

interface Props {
    dataTestId: string;
    children: React.ReactNode;
}
const SplitView = ({ dataTestId, children }: Props) => {
    const totalHeaderHeight = getTotalHeaderHeight();
    return (
        <div data-testid={dataTestId} className={styles.splitViewContainer}>
            <div className={styles.splitViewContent} style={{ top: `${totalHeaderHeight}px` }}>
                {children}
            </div>
        </div>
    );
};

SplitView.Navigation = Navigation;

export default SplitView;
